"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlaylistControls = exports.PlaylistActive = exports.AudioPlaylistControls = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _usePlaylist4 = require("../hooks/usePlaylist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Progress = function Progress(_ref) {
  var type = _ref.type,
    duration = _ref.duration;
  var selectPlaylist = type === _reactSdk.HMSPlaylistType.audio ? _reactSdk.selectAudioPlaylist : _reactSdk.selectVideoPlaylist;
  var progress = (0, _reactSdk.useHMSStore)(selectPlaylist.progress);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var playlistAction = type === _reactSdk.HMSPlaylistType.audio ? hmsActions.audioPlaylist : hmsActions.videoPlaylist;
  if (!duration) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Slider, {
    step: 1,
    value: [progress],
    onValueChange: function onValueChange(e) {
      playlistAction.seekTo(e[0] * 0.01 * duration);
    }
  });
};
var PlaylistActive = function PlaylistActive(_ref2) {
  var _active$metadata, _active$metadata2;
  var type = _ref2.type,
    onToggle = _ref2.onToggle;
  var isAudioPlaylist = type === _reactSdk.HMSPlaylistType.audio;
  var selector = isAudioPlaylist ? _reactSdk.selectAudioPlaylist : _reactSdk.selectVideoPlaylist;
  var active = (0, _reactSdk.useHMSStore)(selector.selectedItem);
  if (!active) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      mt: "$8"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      justify: "between",
      css: {
        w: "100%"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "md",
          children: active.name
        }), ((_active$metadata = active.metadata) === null || _active$metadata === void 0 ? void 0 : _active$metadata.description) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "xs",
          children: (_active$metadata2 = active.metadata) === null || _active$metadata2 === void 0 ? void 0 : _active$metadata2.description
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
        onClick: onToggle,
        css: {
          alignSelf: "center"
        },
        "data-testid": "playlist_collapse_btn",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PlaylistIcon, {})
      })]
    })
  });
};
exports.PlaylistActive = PlaylistActive;
var Controls = function Controls(_ref3) {
  var type = _ref3.type,
    _ref3$css = _ref3.css,
    css = _ref3$css === void 0 ? {} : _ref3$css;
  var _usePlaylist = (0, _usePlaylist4.usePlaylist)(type),
    active = _usePlaylist.active,
    hasNext = _usePlaylist.hasNext,
    hasPrevious = _usePlaylist.hasPrevious,
    actions = _usePlaylist.actions;
  if (!active) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    justify: "center",
    css: css,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      disabled: !hasPrevious,
      onClick: function onClick() {
        actions.playPrevious();
      },
      "data-testid": "playlist_prev_btn",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PrevIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      onClick: function onClick() {
        active.playing ? actions.pause() : actions.play(active.id);
      },
      "data-testid": "playlist_play_pause_btn",
      children: active.playing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PauseIcon, {
        width: 32,
        height: 32
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PlayIcon, {
        width: 32,
        height: 32
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      disabled: !hasNext,
      onClick: function onClick() {
        actions.playNext();
      },
      "data-testid": "playlist_next_btn",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.NextIcon, {})
    })]
  });
};
var VolumeControl = function VolumeControl() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var volume = (0, _reactSdk.useHMSStore)(_reactSdk.selectVideoPlaylist.volume);
  var active = (0, _reactSdk.useHMSStore)(_reactSdk.selectVideoPlaylist.selectedItem);
  var peerSharingPlaylist = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingVideoPlaylist);
  var audioTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectVideoPlaylistAudioTrackByPeerID)(peerSharingPlaylist === null || peerSharingPlaylist === void 0 ? void 0 : peerSharingPlaylist.id));
  var audioTrackVolume = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAudioTrackVolume)(audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.id));
  var sliderVolume = active ? volume : audioTrackVolume;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      color: "$white"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SpeakerIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Slider, {
      css: {
        mx: "$4",
        w: "$20"
      },
      min: 0,
      max: 100,
      step: 1,
      value: [Math.floor(sliderVolume)],
      onValueChange: function onValueChange(e) {
        var value = e[0];
        if (active) {
          hmsActions.videoPlaylist.setVolume(value);
        } else if (audioTrack) {
          hmsActions.setVolume(value, audioTrack.id);
        }
      },
      thumbStyles: {
        w: "$6",
        h: "$6"
      }
    })]
  });
};
var AudioPlaylistControls = function AudioPlaylistControls(_ref4) {
  var onToggle = _ref4.onToggle;
  var _usePlaylist2 = (0, _usePlaylist4.usePlaylist)(_reactSdk.HMSPlaylistType.audio),
    active = _usePlaylist2.active;
  if (!active) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      p: "$8",
      borderTop: "1px solid $borderLight",
      bg: "$menuBg"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Controls, {
      type: _reactSdk.HMSPlaylistType.audio
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Progress, {
      type: _reactSdk.HMSPlaylistType.audio,
      duration: active.duration
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaylistActive, {
      type: _reactSdk.HMSPlaylistType.audio,
      onToggle: onToggle
    })]
  });
};
exports.AudioPlaylistControls = AudioPlaylistControls;
var VideoPlaylistControls = function VideoPlaylistControls(_ref5) {
  var children = _ref5.children;
  var _usePlaylist3 = (0, _usePlaylist4.usePlaylist)(_reactSdk.HMSPlaylistType.video),
    active = _usePlaylist3.active;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      p: "$8",
      mt: "-$24",
      w: "100%",
      zIndex: 1,
      "@lg": {
        mt: 0,
        p: "$6"
      }
    },
    children: [active && /*#__PURE__*/(0, _jsxRuntime.jsx)(Progress, {
      type: _reactSdk.HMSPlaylistType.video,
      duration: active.duration
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      justify: "between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(VolumeControl, {}), active && /*#__PURE__*/(0, _jsxRuntime.jsx)(Controls, {
        css: {
          flex: "1 1 0"
        }
      }), children]
    })]
  });
};
exports.VideoPlaylistControls = VideoPlaylistControls;